"use client";

import React, { useRef, useEffect, useState } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useMotionValueEvent,
} from "framer-motion";

const ParallaxSection = ({
  children,
  speed = 0.5,
  className = "",
  threshold = 0.1,
}) => {
  const [mediaQuery] = useState(window.matchMedia("(min-width: 768px)"));
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    // Only apply parallax effect on desktop

    if (!mediaQuery.matches) return;

    const section = sectionRef.current;
    const content = contentRef.current;
    if (!section || !content) return;

    const handleScroll = () => {
      const rect = section.getBoundingClientRect();
      const scrollPercentage = rect.top / window.innerHeight;
      const distance = section.offsetHeight * speed;
      const transform = scrollPercentage * distance;

      // Apply the transform
      setScrollPosition(transform);
    };

    // Initial position
    handleScroll();

    // Add scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [speed, mediaQuery]);

  return (
    <div
      ref={sectionRef}
      className={`relative overflow-hidden w-full ${className}`}
    >
      <div
        ref={contentRef}
        className="will-change-transform"
        style={{
          transform: `translateY(${-scrollPosition}px)`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export const ParallaxWithFramer = ({
  children,
  speed = 0.05,
  className = "",
  threshold = [0.5, 0.8],
}) => {
  const sectionRef = useRef(null);
  const [mediaQuery] = useState(window.matchMedia("(min-width: 768px)"));
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  const translateY = useTransform(scrollYProgress, threshold, [
    "0%",
    `${speed * 100}%`,
  ]);

  // useMotionValueEvent(scrollYProgress, "change", (latest) => {
  //   console.log(latest);
  // });

  return (
    <div className="relative overflow-hidden w-full">
      <motion.div
        ref={sectionRef}
        style={{ translateY: mediaQuery.matches ? translateY : 0 }}
        transition={{ type: "spring", stiffness: 100, damping: 30 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ParallaxSection;
